import { Form, Input, message, Modal } from "antd";
import { useEffect, useMemo, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import Deletepopup from "../../components/Modal/Deletepopup";

// Updated custom hook paths
import { IoCloseCircleOutline } from "react-icons/io5";
import Actions from "../../components/Common/Actions";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import { PrimaryButton } from "../../components/Common/ButtonComp";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import ListPageLayout from "../../components/Layout";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

const DeliveryAppTrainingCentre = () => {
  const navigate = useNavigate();

  const [authAction, setAuthAction] = useState(""); // 'add', 'edit', 'view'
  const [targetId, setTargetId] = useState("");

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );
  const [loader, setLoader] = useState(true);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [form] = Form.useForm();

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const canAdd = localStorage.getItem("canAddNewVideo") === "true";

  const addNewUgDegree = {
    id: "addnewpost",
    onClick: () => {
      if (canAdd) {
        navigate("/delivery-app-training-centre-create");
      } else {
        setAuthAction("add");
        setShowAuthModal(true);
      }
    },
    className: "addnewhealth",
    style: { width: "240px" },
    label: "Add New Video",
  };

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}delivery-app-training-centre/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "delivery-app-training-centre",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 250,
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: 580,
    },
    {
      title: "Thumbnail",
      // dataIndex: "thumbnail_img",
      render: (_, record) => (
        <img
          src={
            process.env.REACT_APP_API_URL + "thumbnail/" + record.thumbnail_img
          }
          alt={record.thumbnail_img}
          style={{
            width: "150px",
            height: "150px",
            objectFit: "cover",
            borderRadius: "5px",
          }}
        />
      ),
      key: "thumbnail_img",
      width: 580,
    },
    {
      title: "Thumbnail",
      // dataIndex: "thumbnail_img",
      align: "center",
      key: "thumbnail_img",
      render: (_, record) => (
        <img
          src={`${process.env.REACT_APP_API_URL}${record.thumbnail_img}`}
          alt="thumbnail_img"
          style={{
            width: "100px",
            height: "100px",
          }}
        />
      ),
      width: 300,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isEdit={true}
          isDelete={true}
          isView={true}
          onClickView={() => {
            if (canAdd) {
              navigate(`/delivery-app-training-centre-view/${record._id}`);
            } else {
              setAuthAction("view");
              setTargetId(record._id);
              setShowAuthModal(true);
            }
          }}
          isWatchVideo={true}
          onClickWatchVideo={() => {
            setCurrentVideoUrl(record.url);
            setShowVideoModal(true);
          }}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() => {
            if (canAdd) {
              navigate(`/delivery-app-training-centre-edit/${record._id}`);
            } else {
              setAuthAction("edit");
              setTargetId(record._id);
              setShowAuthModal(true);
            }
          }}
        />
      ),
    },
  ];

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Delivery App Training Centre",
        link: "",
      },
    ],
    [],
  );

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  // Add authentication handler
  const handleAuth = (values) => {
    if (values.id === "HealthSy" && values.password === "iz9j3PdZAFaH538C") {
      localStorage.setItem("canAddNewVideo", "true");

      if (authAction === "add") {
        navigate("/delivery-app-training-centre-create");
      } else if (authAction === "edit") {
        navigate(`/delivery-app-training-centre-edit/${targetId}`);
      } else if (authAction === "view") {
        navigate(`/delivery-app-training-centre-view/${targetId}`);
      }

      setShowAuthModal(false);
      form.resetFields();
    } else {
      message.error("Invalid credentials!");
    }
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className=" healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewUgDegree} />}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
      {showAuthModal && (
        <Modal
          title={
            <h6 className="text-primarycolor fs18 fw-bold">
              Authentication Required
            </h6>
          }
          open={showAuthModal}
          onCancel={() => {
            setShowAuthModal(false);
            setAuthAction("");
            setTargetId("");
            form.resetFields();
          }}
          footer={null}
          closeIcon={<IoCloseCircleOutline size={24} />}
          centered
          maskClosable={false}
        >
          <Form
            form={form}
            onFinish={handleAuth}
            layout="vertical"
            className="mt-4"
          >
            <Form.Item
              label={
                <span style={{ color: "#4B4853" }}>
                  ID <span className="star">*</span>
                </span>
              }
              name="id"
              rules={[{ required: true, message: "Please admin ID." }]}
            >
              <Input placeholder="Enter admin ID" />
            </Form.Item>

            <Form.Item
              label={
                <span style={{ color: "#4B4853" }}>
                  Password <span className="star">*</span>
                </span>
              }
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password placeholder="Enter password" />
            </Form.Item>
            <div className="d-flex justify-content-center mt-4">
              <PrimaryButton buttonName="Submit" htmlType="submit" />
            </div>
          </Form>
        </Modal>
      )}
      {showVideoModal && (
        <Modal
          title={
            <h6 className="text-primarycolor fs18 fw-bold">Watch Video</h6>
          }
          open={showVideoModal}
          onCancel={() => setShowVideoModal(false)}
          footer={null}
          closeIcon={<IoCloseCircleOutline size={24} />}
          centered
          width={700}
          maskClosable={false}
        >
          {currentVideoUrl ? (
            <div className="d-flex justify-content-center mt-4">
              <ReactPlayer
                url={currentVideoUrl}
                controls
                width="100%"
                height="360px"
              />
            </div>
          ) : (
            <div>No video URL found.</div>
          )}
        </Modal>
      )}
    </ListPageLayout>
  );
};

export default DeliveryAppTrainingCentre;
